export default __webpack_public_path__ + "static/media/how_image.656c1030.png";